import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@user-portal/wikr-components';

import * as S from '../styled';

import { ISubscriptionCardHeader } from '../../types';

const SubscriptionCardHeader = ({ Icon, heading, isMainSubscription, productCode }: ISubscriptionCardHeader) => {
    const { t } = useTranslation();
    const isAdditionalSubscription = !isMainSubscription;
    const productCodesToBeDisplayed = productCode?.split('__');

    return (
        <S.SubscriptionCardHeader>
            <S.Name>
                <Icon />
                {isMainSubscription && (
                    <Text dataLocator="subscriptionTitle" type="large-text" color="text-main">
                        {t(heading)}
                    </Text>
                )}
                {/* <Box>*/}
                {isAdditionalSubscription &&
                    productCodesToBeDisplayed?.length > 0 &&
                    productCodesToBeDisplayed.map((productCode, index) => (
                        <React.Fragment key={productCode}>
                            <Text dataLocator="subscriptionTitle" type="large-text" inline={true}>
                                {t(heading, { plan: productCode })}
                            </Text>
                            {index < productCodesToBeDisplayed.length - 1 && <Text inline>+</Text>}
                        </React.Fragment>
                    ))}
                {/* </Box>*/}
            </S.Name>
        </S.SubscriptionCardHeader>
    );
};

export default SubscriptionCardHeader;
